<template>
  <v-card>
    <ValidateAll ref="form">
      <v-card-text>
        <v-form>
          <v-row>
            <v-col cols="12" md="6">
              <div class="headline">{{title()}}</div>
              <br />
              <!-- form goes here -->
              <v-skeleton-loader
                :loading="loading"
                class="actions__left"
                type="list-item-two-line,list-item-two-line, actions"
              >
                <Validate name="Nama" rules="required" #default="{ errors }">
                  <v-text-field
                    class="mb-3"
                    name="Name"
                    label="Nama"
                    :error-messages="errors"
                    placeholder="Nama"
                    v-model="form.Name"
                    hide-details="auto"
                    outlined
                    required
                    dense
                  ></v-text-field>
                </Validate>
                <Validate name="Username" rules="required" #default="{ errors }">
                  <v-text-field
                    class="mb-3"
                    name="Username"
                    label="Username"
                    :error-messages="errors"
                    placeholder="Username"
                    v-model="form.Username"
                    hide-details="auto"
                    outlined
                    required
                    dense
                  ></v-text-field>
                </Validate>
                <Validate name="Email" rules="required|email" #default="{ errors }">
                  <v-text-field
                    class="mb-3"
                    name="Email"
                    label="Email"
                    :error-messages="errors"
                    placeholder="Email"
                    v-model="form.Email"
                    hide-details="auto"
                    outlined
                    required
                    dense
                  ></v-text-field>
                </Validate>
                <Validate name="Password" :rules="!form.ID?'required':''" #default="{ errors }">
                  <v-text-field
                    v-model="form.Password"
                    label="Password"
                    name="password"
                    type="password"
                    class="mb-3"
                    placeholder="Password"
                    hide-details="auto"
                    :error-messages="errors"
                    outlined
                    dense
                  ></v-text-field>
                </Validate>
                <Validate name="Grup" rules #default="{ errors }">
                  <v-autocomplete
                    class="mb-3"
                    :items="list.grup.data"
                    item-text="Name"
                    item-value="IDGroup"
                    name="Grup"
                    label="Grup"
                    :error-messages="errors"
                    placeholder="Grup"
                    hide-details="auto"
                    v-model="form.GroupID"
                    :return-object="false"
                    @change="selectSekolah"
                    outlined
                    dense
                  ></v-autocomplete>
                </Validate>
                <v-autocomplete
                  v-show="showSekolah"
                  class="mb-3"
                  :items="list.sekolah.data"
                  item-text="Nama"
                  item-value="IDSekolah"
                  name="Sekolah"
                  label="Sekolah"
                  placeholder="Sekolah"
                  hide-details="auto"
                  v-model="form.IDSekolah"
                  :return-object="false"
                  outlined
                  dense
                >
                  <!-- selected slot -->
                  <template v-slot:selection="data">
                    <v-list-item-title>
                      {{data.item.Nama}}
                      &mdash;
                      <span
                        class="text--secondary"
                      >{{data.item.Kode}}</span>
                    </v-list-item-title>
                  </template>
                  <!-- list item slot -->
                  <template v-slot:item="data">
                    <template v-if="typeof data.item !== 'object'">
                      <v-list-item-content v-text="data.item"></v-list-item-content>
                    </template>
                    <template v-else>
                      <v-list-item-content>
                        <v-list-item-title class="py-0">
                          {{data.item.Nama}}
                          &mdash;
                          <span
                            class="text--secondary"
                          >{{data.item.Kode}}</span>
                        </v-list-item-title>
                        <v-list-item-subtitle>{{ data.item.Alamat}} {{ data.item.Lokasi}} {{data.item.Provinsi}}</v-list-item-subtitle>
                      </v-list-item-content>
                    </template>
                  </template>
                </v-autocomplete>
                <Validate name="Status">
                  <v-switch v-model="form.Status" inset label="Status"></v-switch>
                </Validate>
                <v-btn class="mr-2" @click="reset">Ulang</v-btn>
                <v-btn color="primary" @click="save()" :loading="saving">
                  <v-icon>mdi-content-save</v-icon>Simpan
                </v-btn>
              </v-skeleton-loader>
            </v-col>
            <v-divider vertical class="hidden-xs-only" />
            <v-col cols="12" md="6" class="mr-n1"></v-col>
          </v-row>
        </v-form>
      </v-card-text>
    </ValidateAll>
  </v-card>
</template>

<script>
import { mapState, mapActions, mapGetters } from "vuex";
export default {
  data: () => ({
    saving: false,
    loading: false,
    showSekolah: false,
    form: {
      Name: "",
      Username: "",
      Email: "",
      Password: "",
      GroupID: "",
      IDSekolah: "",
      Status: false
    }
  }),
  computed: {
    ...mapState({
      app: state => state.app,
      list: state => state.list
    }),
    ...mapGetters("list", ["isPenggunaLoading"])
  },
  methods: {
    async save() {
      const valid = await this.$refs.form.validate();
      if (!valid) return;
      this.form.Status = this.form.Status ? 1 : 0;
      const confirmation = await this.$dialog.confirm({
        text: "Apakah anda yakin menyimpan data?"
      });
      if (!confirmation) return;

      this.saving = true;
      this.$axios
        .post("/user", this.form)
        .then(res => {
          this.$dialog.notify.success(res.data.Message, {
            ...this.app.notification
          });
          this.$router.push("/pengaturan/pengguna");
        })
        .catch(error => {
          this.$dialog.notify.error(error, {
            ...this.app.notification
          });
        })
        .finally(() => {
          this.saving = false;
        });
    },
    selectSekolah() {
      if (this.form.GroupID) {
        var groups = this.list.grup.data.filter(
          g => g.IDGroup == this.form.GroupID
        );
        if (groups[0].Type == "sekolah") {
          this.refreshSekolah(groups[0].IDGroup);
          this.showSekolah = true;
        } else {
          this.showSekolah = false;
          this.form.IDSekolah = "";
        }
      } else {
        this.showSekolah = false;
        this.form.IDSekolah = "";
      }
    },
    reset() {
      // Object.assign(this.$data, this.$options.data());
      this.$refs.form.reset();
    },
    title() {
      return this.$route.params.id ? "Ubah Pengguna" : "Pengguna Baru";
    },

    ...mapActions("list", ["refreshGrup", "refreshSekolah"])
  },
  async mounted() {
    this.refreshGrup();
    this.refreshSekolah();
    let id = this.$route.params.id;
    if (id) {
      this.loading = true;
      this.$axios
        .get(`/user/${id}`)
        .then(res => {
          this.loading = false;
          this.form = { ...this.form, ...res.data.Data };
          this.form.Status = res.data.Data.Status > 0 ? true : false;
          if (this.form.IDSekolah) this.showSekolah = true;
        })
        .catch(error => {
          this.$dialog.notify.error(error, {
            position: this.app.notification.position
          });
        });
    }
  }
};
</script>

<style>
</style>